import { useMediaQuery } from '@rbx/ui';

export default function useResponsiveDesign() {
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('Large'));
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('Medium'));
  return {
    isDesktop,
    isTablet: !isDesktop && !isMobile,
    isMobile,
  };
}
